import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-committee',
  templateUrl: './committee.component.html',
  styleUrls: ['./committee.component.css']
})
export class CommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
